import { PORTFOLIO_ADMIN_CONSTANTS as C } from '../../_Shared/_MODULES/PortfolioAdminApi';
export const PROFILE_ADMIN_API = {
    PROFILE_GET: C.PROFILE_GET, PROFILE_SAVE: C.PROFILE_SAVE,
    ABOUT_GET: C.ABOUT_GET, ABOUT_SAVE: C.ABOUT_SAVE,
    STATS_LIST: C.STATS_LIST, STATS_SAVE: C.STATS_SAVE, STATS_REMOVE: C.STATS_REMOVE,
    SKILLS_LIST: C.SKILLS_LIST, SKILLS_SAVE: C.SKILLS_SAVE, SKILLS_REMOVE: C.SKILLS_REMOVE,
};
